function updatePromotionCode(data) {

    $('.block-promotioncode .info').html('');
    $('.block-promotioncode .notification').html('');
    $('input[name=discountcode]').attr('readonly', false);
    $('.block-promotioncode')
        .removeClass('block-promotioncode-info')
        .addClass('block-promotioncode-input');

    if (typeof data.promocode == 'undefined' ||
        data.promocode.code === false) {
        $('input[name=discountcode]').val('');
        return;
    }

    //has text
    if (typeof data.promocode.text != 'undefined') {
        $('.block-promotioncode .info').html(data.promocode.text);
    }

    //has notification
    if (typeof data.promocode.notification != 'undefined') {
        $('.block-promotioncode .notification').html(data.promocode.notification);
    }

    //has code
    if (typeof data.promocode.code !== false) {
        $('.block-promotioncode')
            .addClass('block-promotioncode-info')
            .removeClass('block-promotioncode-input');
        $('input[name=discountcode]').attr('readonly', true);
    }
}

function doCallPromo(type) {

    console.log('3');

    let params = {
        code: $('input[name=discountcode]').val()
    };

    if ($('#page').hasClass('checkout')) {
        params.shipment = $('input[name=shipment]:checked').val();
        params.customer_type = $('#customer_type').val();
        params.vat = $('#customer_type').val() == 'business' && $('#company_vat').length > 0
            ? $('#company_vat').val()
            : '';
        params.country = $('#invoice-address').is(':checked')
            ? $('#address_1_country').val()
            : $('#address_2_country').val();
        params.email = $('#address_1_email').val().trim()
    }

    $.ajax({
        url: config.domain + '/frontend/functions/cart_promotioncode_' + type + '.php?action=1',
        type: 'POST',
        dataType: 'json',
        data: params,
        'success': function (data) {

            if ($('#page').hasClass('checkout')) {
                console.log('ddd');
                calculateTotals();
            } else {
                if (type = 'delete'){
                    updateCart(data);
                }
                updateTotals(data);
            }

            updatePromotionCode(data);
        }
    });
}

$(function () {

    $(document).on('click', '.btn-promocode-add', function () {
        doCallPromo('add');
    });

    $(document).on('click', '.btn-promocode-delete', function () {
        doCallPromo('delete');
    });
});